var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIconCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2743 26.5013C20.6055 26.5013 26.5486 20.5688 26.5486 13.2507C26.5486 5.93253 20.6055 0 13.2743 0C5.9431 0 0 5.93253 0 13.2507C0 20.5688 5.9431 26.5013 13.2743 26.5013Z",
    fill: "var(--neutral-950-main, #1D1F2A)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIconCircle);
export default __webpack_public_path__ + "static/media/error-icon-circle.020e368697b3d579317efcc3283c4e71.svg";
export { ForwardRef as ReactComponent };